import styled from 'styled-components';

export const Close = styled.div`
  width: 100%;
  padding: 1rem;
  display: flex;
  align-item: flex-end;
  justify-content: flex-end;
`;
